import React from 'react';
import { FILTER_PRESETS } from 'constants/filters';
import FilterPresetButton from './FilterPresetButton';

export default function CinematicFilter() {
  return (
    <FilterPresetButton
      presetKey={FILTER_PRESETS.CINEMATIC}
      label="Cinematic"
      image="cinematic"
      thumbnailClassName="bg-gradient-to-br from-slate-900 via-teal-700 to-amber-200"
    />
  );
}
